document.addEventListener("DOMContentLoaded", function () {
  let footerLinks = document.querySelector(".footer-links");
  if (!footerLinks) return; // Prevents errors if .footer-links is missing

  let alwaysOpenTitles = footerLinks.dataset.alwaysOpen
    ? footerLinks.dataset.alwaysOpen.split(",").map((title) => title.trim())
    : [];

  function updateFooterDropdowns() {
    let isMobile = window.matchMedia("(max-width: 749px)").matches;

    document.querySelectorAll(".footer-column-title").forEach(function (title) {
      let parentColumn = title.closest(".footer-column");
      let dropdown = parentColumn.querySelector(".footer-dropdown");
      let openIcon = title.querySelector(".footer-column-title__open-icon");
      let closeIcon = title.querySelector(".footer-column-title__close-icon");
      let titleText = title.textContent.trim();

      if (isMobile) {
        if (alwaysOpenTitles.includes(titleText)) {
          parentColumn.classList.add("open");
          dropdown.style.display = "block";
          if (openIcon) openIcon.style.display = "none";
          if (closeIcon) closeIcon.style.display = "none";
        } else {
          title.onclick = function () {
            let isOpen = parentColumn.classList.toggle("open");
            dropdown.style.display = isOpen ? "block" : "none";
          };
        }
      } else {
        parentColumn.classList.add("open");
        dropdown.style.display = "block";
      }
    });
  }

  updateFooterDropdowns();

  window.addEventListener("resize", updateFooterDropdowns);
});
